if (!customElements.get('product-info-tabs')) {
  customElements.define(
    'product-info-tabs',
    class ProductInfoTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.tabs.forEach((tab) => tab.addEventListener('click', () => this.select(tab)));
        this.addEventListener('keydown', this.onKeyDown.bind(this));
      }

      select(tab) {
        this.tabs.forEach((other) => {
          const selected = other === tab;
          other.setAttribute('aria-selected', selected);
          other.tabIndex = selected ? 0 : -1;
          document.getElementById(other.getAttribute('aria-controls')).hidden = !selected;
        });
      }

      onKeyDown(event) {
        const index = this.tabs.indexOf(event.target);
        if (index === -1) return;

        let next = null;
        if (event.key === 'ArrowRight') next = this.tabs[(index + 1) % this.tabs.length];
        if (event.key === 'ArrowLeft') next = this.tabs[(index - 1 + this.tabs.length) % this.tabs.length];
        if (!next) return;

        event.preventDefault();
        this.select(next);
        next.focus();
      }
    }
  );
}
